exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-ve-divider__line[data-v-08973d41] {\n  width: 100%;\n}\n", ""]);

// exports
